// pages/About.js
import React from 'react';
import { Target, Globe, Heart, Users } from 'lucide-react';
import carImage from "../assets/car1.png"; // or any car image
import { Eye } from "lucide-react";
import prakhar from "../assets/prakhar.jpeg"
import aman from "../assets/aman.jpeg"
import kunal from "../assets/kunal.jpeg"
import innovationIcon from "../assets/4.svg";


const About = () => {
  return (
    <div className="page">
      {/* <section className="about-hero">
        <div className="about-hero-content">
          <h1>About <span className="highlight">Drivve</span></h1>
          <p className="subtitle">Redefining urban mobility through shared journeys</p>
        </div>
      </section>
       */}
      <section className="about-content">
        <div className="about-story">
          <div className="about-text">
            <h1 style={{color:"#184080"}}>Our Story</h1>
         <p>
  Founded in April 2025, Drivve&trade; was born from a simple realization: that everyday commuting needed a smarter approach. As urban congestion and travel costs reach all-time highs, we saw an opportunity to transform the daily grind into something smarter and more sustainable.

</p>

<p>
  Drivve&trade; bridges the gap between people on the same path, turning solo commutes into shared journeys. By optimizing routes and resources, we don't just reduce traffic and carbon footprints—we build a community centered on efficiency and meaningful connection. Drivve is more than a platform - it’s a smarter way to move, a better way to connect, and the way to drive our cities into a greener tomorrow.

</p>

          </div>
       <div className="about-image">
  <img
    src={carImage}
    alt="Drivve carpooling community"
    className="about-car-image"
  />
</div>

        </div>
        
        <div className="mission-vision">
          <div className="mission">
            <div className="mission-icon">
              <Target size={32} />
            </div>
            <h2 >Our Mission</h2>
            <p>To transform urban mobility by making carpooling the most convenient, affordable, and sustainable transportation option for everyone.</p>
          </div>
          
          <div className="vision">
            <div className="vision-icon">
              <Eye size={32} />
            </div>
            <h2 >Our Vision</h2>
            <p>A world where shared transportation reduces traffic congestion, lowers carbon emissions, and strengthens community connections.</p>
          </div>
        </div>
        
        <div className="values">
          <h1 style={{ color: "#184080", textAlign: "center" }}>Our Core Values</h1>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Users size={28} />
              </div>
              <h4 style={{fontSize:"20px"}}>Community</h4>
              <p>We strive to create meaningful connections built on trust among our users.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <Globe size={28} />
              </div>
              <h4 style={{fontSize:"20px"}}>Sustainability</h4>
              <p>Every shared ride contributes to a cleaner and greener planet.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <Heart size={28} />
              </div>
              <h4 style={{fontSize:"20px"}}>Safety First</h4>
              <p>We prioritize the safety and security of our community above all else.</p>
            </div>
            
            <div className="value-card">
  <div className="value-icon">
    <img
      src={innovationIcon}
      alt="Innovation"
      style={{
        width: "38px",
        height: "38px",
        objectFit: "contain",
      }}
    />
  </div>

  <h4 style={{ fontSize: "20px" }}>Innovation</h4>

  <p style={{ color: "rgba(19,15,15,0.75)" }}>
    Continuously improving our technology to enhance the user experience.
  </p>
</div>
          </div>
        </div>
        
        <div className="team">
          <h1 style={{ color: "#184080", textAlign: "center" }}>Meet Our Leadership</h1>
          <div className="team-grid">
            <div className="team-member">
                     <div
  className="member-photo"
  style={{
    width: "150px",
    height: "150px",
    borderRadius: "50%", // circle
    overflow: "hidden",   // crop excess
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <img
    src={aman} // path to your image
    alt="Aman Jain"
    style={{
      width: "100%",     // fill container
      height: "100%",    // fill container
      objectFit: "cover" // crop without distortion
    }}
  />
</div>
              <h2>Aman Jain</h2>
              <p className="role" style={{fontSize:"20px"}}>Co-founder</p>
              {/* <p className="bio">Former transportation planner with 15+ years experience.</p> */}
            </div>
            
            <div className="team-member">
             <div
  className="member-photo"
  style={{
    width: "150px",
    height: "150px",
    borderRadius: "50%", // circle
    overflow: "hidden",   // crop excess
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <img
    src={prakhar} // path to your image
    alt="Prakhar Gupta"
    style={{
      width: "100%",     // fill container
      height: "100%",    // fill container
      objectFit: "cover" // crop without distortion
    }}
  />
</div>

              <h2>Prakhar Gupta</h2>
              <p className="role" style={{fontSize:"20px"}}>Co-founder</p>
              {/* <p className="bio">Tech innovator focused on sustainable mobility solutions.</p> */}
            </div>
            
            <div className="team-member">
                      <div
  className="member-photo"
  style={{
    width: "150px",
    height: "150px",
    borderRadius: "50%", // circle
    overflow: "hidden",   // crop excess
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <img
    src={kunal} // path to your image
    alt="Kunal Rana"
    style={{
      width: "100%",     // fill container
      height: "100%",    // fill container
      objectFit: "cover" // crop without distortion
    }}
  />
</div>
              <h2>Kunal Rana</h2>
              <p className="role" style={{fontSize:"20px"}}>Co-founder</p>
              {/* <p className="bio">Expert in scaling community-driven platforms.</p> */}
            </div>
              
            {/* <div className="team-member">
              <div className="member-photo">SC</div>
              <h4>Shashank Varshney</h4>
              <p className="role">Co-founder</p>
              <p className="bio">Expert in scaling community-driven platforms.</p>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;